import React, { useState } from 'react'
import bg from '../../images/aspirationBanner.webp'
import { useDispatch, useSelector } from 'react-redux';
import ToggleMenu from '../common/ToggleMenu'
import ContactModal from './ContactModal';
import { setToggleTrue } from '../../redux/slice/changeState'
import { useMediaQuery } from 'react-responsive';
import { Row, Col } from 'react-bootstrap';

const MobileBanner = () => {
  const isTablet = useMediaQuery({ query: '(min-width: 769px) and (max-width: 991px)' });
  const dispatch = useDispatch()
  const toggle = useSelector((state) => state.toggle);

  return (
    <>
      <div className='text-center banner' style={{ backgroundImage: `url('/aspirationmobile.png')` }}>
        <ToggleMenu />

        <div className='banner-title'>
          <img src="/IRA-White1mobile.png" className='' alt="aspiration"></img>
          <img src="/Aspirationmobile.png" className='' alt="aspiration"></img>
        </div>
        <div className='banner-discption'>
          <h1 className='' >Ready-to-Move In Luxury 2&3 BHK Apartments In Kollur starting At ₹1.20 Cr.</h1>
          {/* <p className=''>FREE Furnishings worth 8,88,888 INR</p> */}

          <p className='mb-4'>Find Your Future Home Today</p>
          <div>
            <button className='visit-btn' onClick={() => dispatch(setToggleTrue())}>Book a Visit</button>
          </div>
          <div>
            <button className='explore-btn'><a href='https://wa.api-whatsapp.in/ehbv4C' target="_blank" rel="noreferrer">Chat on Whatsapp</a></button>
          </div>
          <div className='container mt-5 px-5 ' style={{
            maxWidth : "400px"
          }}>
                        <Row className='border border-white'>
                            <Col lg={12} md={12} xs={12} className='border-bottom  py-1'>
                                <p className="small-text">Layout/Building/Permission No.</p>
                                <p className='large-text'>File No. 036703/SKP/R1/U6/HMDA/19062020</p>
                            </Col>

                            <Col lg={12} md={12} xs={12} className='  py-1'>
                                <p className='large-text'>
                                    TG RERA Registration No. <span>P01100002880</span>
                                </p>
                                <p className="small-text">
                                    Website: rera.telangana.gov.in
                                </p>
                            </Col>


                        </Row>

                        
                    </div>
        </div>

      </div>
      {
        toggle.hastoggle && <ContactModal />
      }
    </>
  )
}

export default MobileBanner
